module.exports = __webpack_public_path__ + "img/top-bar.e0e24dd7.png";